import { useAuth } from '@/contexts/AuthContext';
import { Navigate, Outlet } from 'react-router';

export default function AdminRoute() {
  const { isAdmin } = useAuth();
  return isAdmin() ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
